import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './lang/en.json'
import es from './lang/es.json'
import pt from './lang/pt.json'
import appConfig from 'configs/app.config'

const resources = {
    en: {
        translation: en,
    },
    es: {
        translation: es,
    },
    pt: {
        translation: pt,
    },
}

// Create a global variable to store the current app name
// This will be updated by our context provider
window.__APP_NAME__ = 'Followr';

// Store the original t function
const originalTFunction = i18n.t.bind(i18n);

// Override the t function to replace "Followr" with dynamic app name
i18n.t = function(key, options = {}) {
    // Get the original translation
    let translation = originalTFunction(key, options);
    
    // Get app name from options, global variable, or use default
    const appName = options.appName || window.__APP_NAME__ || 'Followr';
    
    // Replace all occurrences of "Followr" with the app name
    if (typeof translation === 'string') {
        translation = translation.replace(/Followr/g, appName);
    }
    
    return translation;
};

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: appConfig.locale,
    lng: appConfig.locale,
    interpolation: {
        escapeValue: false,
    },
})

export const dateLocales = {
    en: () => import('dayjs/locale/en'),
    es: () => import('dayjs/locale/es'),
    pt: () => import('dayjs/locale/pt'),
}

// Helper function to update the app name from anywhere in the app
export const updateAppName = (newAppName) => {
    window.__APP_NAME__ = newAppName;
};

export default i18n